export const IMPACT_CENTER_METRICS = "impact-center/metrics";
export const IMPACT_CENTER_XRAY_ADOPTION = "impact-center/xray/adoption";
export const IMPACT_CENTER_CURATION_OVERVIEW =
  "impact-center/curation/overview";
export const IMPACT_CENTER_ARTIFACTORY_STORAGE_INFO =
  "impact-center/artifactory/storage-info";
